export const EMAIL_FONT_FAMILIES = [
    'Roboto',
    'Open Sans',
    'Noto Sans JP',
    'Lato',
    'Montserrat',
    'Poppins',
    'Roboto Condensed',
    'Source Sans Pro',
    'Oswald',
    'Noto Sans',
    'Roboto Mono',
    'Raleway',
    'Inter',
    'Ubuntu',
    'Mukta',
    'Nunito',
    'Roboto Slab',
    'Merriweather',
    'PT Sans',
    'Playfair Display',
    'Rubik',
    'Nunito Sans',
    'Noto Sans KR',
    'Work Sans',
    'Lora',
    'Nanum Gothic',
    'Noto Sans TC',
    'Fira Sans',
    'Quicksand',
    'Barlow',
    'Hind Siliguri',
    'PT Serif',
    'Titillium Web',
    'Mulish',
    'Inconsolata',
    'Heebo',
    'Noto Serif',
    'IBM Plex Sans',
    'Josefin Sans',
    'Kanit',
    'Libre Franklin',
    'Karla',
    'DM Sans',
    'Dosis',
    'Libre Baskerville',
    'Arimo',
    'PT Sans Narrow',
    'Oxygen',
    'Bebas Neue',
    'Cairo',
    'Bitter',
    'Source Code Pro',
    'Noto Sans SC',
    'Dancing Script',
    'Anton',
    'Source Serif Pro',
    'EB Garamond',
    'Cabin',
    'Prompt',
    'Barlow Condensed',
    'Signika Negative',
    'Lobster',
    'Hind',
    'Abel',
    'M PLUS Rounded 1c',
    'Varela Round',
    'Fjalla One',
    'Comfortaa',
    'Crimson Text',
    'Exo 2',
    'Pacifico',
    'Manrope',
    'Maven Pro',
    'Arvo',
    'Noto Sans HK',
    'Overpass',
    'Archivo',
    'Hind Madurai',
    'Yanone Kaffeesatz',
    'Noto Serif JP',
    'Merriweather Sans',
    'Teko',
    'Abril Fatface',
    'Asap',
    'Rajdhani',
    'Shadows Into Light',
    'Secular One',
    'Indie Flower',
    'Caveat',
    'Assistant',
    'Questrial',
    'Jost',
    'Slabo 27px',
    'Catamaran',
    'IBM Plex Serif',
    'Public Sans',
    'Zilla Slab',
    'Fira Sans Condensed',
    'Barlow Semi Condensed',
    'Red Hat Display',
    'Cormorant Garamond',
    'Bree Serif',
    'ABeeZee',
    'Tajawal',
    'Domine',
    'Permanent Marker',
    'Archivo Narrow',
    'Signika',
    'Satisfy',
    'IBM Plex Mono',
    'Play',
    'Nanum Myeongjo',
    'Vollkorn',
    'Acme',
    'M PLUS 1p',
    'Space Grotesk',
    'Alfa Slab One',
    'Sarabun',
    'Exo',
    'Righteous',
    'Chakra Petch',
    'Amatic SC',
    'Alegreya Sans',
    'Fredoka One',
    'Alegreya',
    'Cinzel',
    'Noto Sans Arabic',
    'Russo One',
    'Kalam',
    'Martel',
    'Yantramanav',
    'Padauk',
    'Tinos',
    'Saira Condensed',
    'Ubuntu Condensed',
    'Cardo',
    'DM Serif Display',
    'Noto Sans Display',
    'Patua One',
    'Didact Gothic',
    'Great Vibes',
    'Archivo Black',
    'Frank Ruhl Libre',
    'Crete Round',
    'Courgette',
    'Lobster Two',
    'Amiri',
    'Space Mono',
    'Noto Serif TC',
    'Staatliches',
    'Cookie',
    'Prata',
    'Baloo 2',
    'PT Sans Caption',
    'Volkhov',
    'Changa',
    'Patrick Hand',
    'Cormorant',
    'Kaushan Script',
    'Antic Slab',
    'Asap Condensed',
    'Old Standard TT',
    'Rokkitt',
    'Noticia Text',
    'Pathway Gothic One',
    'Spectral',
    'Noto Kufi Arabic',
    'Francois One',
    'Encode Sans',
    'Almarai',
    'Chivo',
    'Paytone One',
    'Quattrocento Sans',
    'Passion One',
    'Michroma',
    'Cantarell',
    'Sacramento',
    'Orbitron',
    'Sora',
    'Concert One',
    'Sawarabi Mincho',
    'Luckiest Guy',
    'PT Mono',
    'Montserrat Alternates',
    'Saira Semi Condensed',
    'Gloria Hallelujah',
    'Alata',
    'Lexend Deca',
    'Gothic A1',
    'News Cycle',
    'Gelasio',
    'Unna',
    'Press Start 2P',
    'Quattrocento',
    'Yeseva One',
    'Mali',
    'Playfair Display SC',
    'Advent Pro',
    'Cuprum',
    'Josefin Slab',
    'Sen',
    'Taviraj',
    'Carter One',
    'Faustina',
    'Ropa Sans',
    'Philosopher',
    'Yellowtail',
    'Marcellus',
    'Mitr',
    'Bangers',
    'Poiret One',
    'Special Elite',
    'Saira',
    'Ultra',
    'Fira Sans Extra Condensed',
    'Sawarabi Gothic',
    'Encode Sans Condensed',
    'Oleo Script Swash Caps',
    'Commissioner',
    'Neuton',
    'Noto Serif KR',
    'Vidaloka',
    'Marck Script',
    'Alice',
    'Lexend',
    'Khand',
    'Handlee',
    'Mukta Malar',
    'El Messiri',
    'Noto Serif SC',
    'Aleo',
    'Itim',
    'Neucha',
    'Homemade Apple',
    'Parisienne',
    'Tangerine',
    'Monda',
    'Architects Daughter',
    'Mr Dafoe',
    'Crimson Pro',
    'Bungee',
    'Ubuntu Mono',
    'Oleo Script',
    'Sanchez',
    'Playball',
    'Ruda',
    'Eczar',
    'Allura',
    'Amaranth',
    'Syncopate',
    'Outfit',
    'Gudea',
    'Quantico',
    'Lusitana',
    'Rubik Mono One',
    'Titan One',
    'Viga',
    'Alegreya Sans SC',
    'Actor',
    'Hammersmith One',
    'Jura',
    'Urbanist',
    'Hind Vadodara',
    'Source Serif 4',
    'Istok Web',
    'IBM Plex Sans Arabic',
    'Pangolin',
    'Red Hat Text',
    'IBM Plex Sans Condensed',
    'Kosugi Maru',
    'Be Vietnam Pro',
    'Black Han Sans',
    'Cabin Condensed',
    'Nanum Pen Script',
    'Arsenal',
    'DM Serif Text',
    'Rock Salt',
    'Khula',
    'Berkshire Swash',
    'Bai Jamjuree',
    'Nanum Gothic Coding',
    'Mada',
    'Pontano Sans',
    'Noto Sans Thai',
    'Palanquin',
    'Bad Script',
    'Merienda',
    'Adamina',
    'Gruppo',
    'Basic',
    'Cousine',
    'Fugaz One',
    'Lilita One',
    'Black Ops One',
    'Gentium Book Basic',
    'Ramabhadra',
    'Sriracha',
    'Alex Brush',
    'Karma',
    'Unica One',
    'Coda',
    'Monoton',
    'Baskervville',
    'Literata',
    'BenchNine',
    'Julius Sans One',
    'Martel Sans',
    'Sorts Mill Goudy',
    'Pragati Narrow',
    'Fira Mono',
    'Caveat Brush',
    'Damion',
    'Economica',
    'Sigmar One',
    'Tenor Sans',
    'Blinker',
    'Noto Naskh Arabic',
    'Abhaya Libre',
    'Alef',
    'Yrsa',
    'Armata',
    'Forum',
    'Nothing You Could Do',
    'Lalezar',
    'Shrikhand',
    'Bodoni Moda',
    'Varela',
    'Sintony',
    'Laila',
    'Niramit',
    'League Spartan',
    'Sarala',
    'Pridi',
    'Antic',
    'Arapey',
    'Audiowide',
    'Share Tech Mono',
    'Rozha One',
    'Electrolize',
    'Overlock',
    'Castoro',
    'Allerta',
    'Sansita',
    'Cantata One',
    'Rufina',
    'Arima Madurai',
    'Krub',
    'Aclonica',
    'Athiti',
    'Courier Prime',
    'Glegoo',
    'Shadows Into Light Two',
    'Six Caps',
    'Italianno',
    'Kumbh Sans',
    'Anonymous Pro',
    'Covered By Your Grace',
    'Boogaloo',
    'Cambay',
    'Lemonada',
    'Fredericka the Great',
    'Rancho',
    'Noto Sans Tamil',
    'Reenie Beanie',
    'Jaldi',
    'Leckerli One',
    'Palanquin Dark',
    'Creepster',
    'Alatsi',
    'Squada One',
    'K2D',
    'Chewy',
    'Pinyon Script',
    'Cabin Sketch',
    'Enriqueta',
    'Spinnaker',
    'Kreon',
    'Comic Neue',
    'Kameron',
    'Cutive Mono',
    'Darker Grotesque',
    'Racing Sans One',
    'Pattaya',
    'Saira Extra Condensed',
    'Candal',
    'Capriola',
    'Libre Caslon Text',
    'PT Serif Caption',
    'Allerta Stencil',
    'Holtwood One SC',
    'Hind Guntur',
    'Epilogue',
    'Fira Code',
    'Annie Use Your Telescope',
    'Jua',
    'Mate',
    'Gochi Hand',
    'Bowlby One SC',
    'Overpass Mono',
    'Belleza',
    'Voltaire',
    'Herr Von Muellerhoff',
    'Bevan',
    'Londrina Solid',
    'Mrs Saint Delafield',
    'Niconne',
    'Macondo',
    'Atkinson Hyperlegible',
    'VT323',
    'Markazi Text',
    'Syne',
    'Trirong',
    'Biryani',
    'Average Sans',
    'Readex Pro',
    'Coming Soon',
    'Graduate',
    'Amita',
    'Reem Kufi',
    'Gilda Display',
    'Charm',
    'Mukta Vaani',
    'Caudex',
    'Short Stack',
    'Telex',
    'Cinzel Decorative',
    'Roboto Flex',
    'Tillana',
    'Nanum Brush Script',
    'Plus Jakarta Sans',
    'Arizonia',
    'Changa One',
    'Rambla',
    'Zen Maru Gothic',
    'Norican',
    'Suez One',
    'Rye',
    'Carrois Gothic',
    'Fraunces',
    'Alike Angular',
    'Kristi',
    'Mandali',
    'Delius',
    'Aldrich',
    'Big Shoulders Display',
    'Maitree',
    'Oranienbaum',
    'Just Another Hand',
    'Corben',
    'Bungee Inline',
    'Days One',
    'BioRhyme',
    'Krona One',
    'Trocchi',
    'Arbutus Slab',
    'Chonburi',
    'Cormorant Infant',
    'Scada',
    'Miriam Libre',
    'Magra',
    'La Belle Aurore',
    'Rochester',
    'Average',
    'Quintessential',
    'STIX Two Text',
    'Contrail One',
    'JetBrains Mono',
    'Yesteryear',
    'Shippori Mincho',
    'Manjari',
    'Antonio',
    'Alegreya SC',
    'Lateef',
    'Noto Sans Devanagari',
    'Mate SC',
    'Judson',
    'IM Fell English SC',
    'Seaweed Script',
    'Suranna',
    'Lustria',
    'Halant',
    'Sniglet',
    'Marcellus SC',
    'Do Hyeon',
    'Henny Penny',
    'GFS Didot',
    'Esteban',
    'Calistoga',
    'Nixie One',
    'Fauna One',
    'Cedarville Cursive',
    'Bowlby One',
    'Noto Sans Malayalam',
    'Grand Hotel',
    'Ovo',
    'Libre Barcode 39',
    'Rammetto One',
    'Coustard',
    'Rosario',
    'Nobile',
    'Bubblegum Sans',
    'Sofia',
    'Fresca',
    'Share',
    'NTR',
    'Kosugi',
    'Hi Melody',
    'Grandstander',
    'Alike',
    'Noto Serif Display',
    'DM Mono',
    'Averia Serif Libre',
    'Qwitcher Grypen',
    'Amiko',
    'Petit Formal Script',
    'Knewave',
    'Aladin',
    'Sunflower',
    'Amethysta',
    'Slabo 13px',
    'Kite One',
    'Averia Libre',
    'Noto Serif Bengali',
    'Calligraffitti',
    'Merienda One',
    'Noto Sans Telugu',
    'Skranji',
    'David Libre',
    'Monsieur La Doulaise',
    'Wallpoet',
    'Livvic',
    'Balsamiq Sans',
    'Dongle',
    'Molengo',
    'Proza Libre',
    'Bellefair',
    'Qwigley',
    'Arya',
    'Baloo Thambi 2',
    'Podkova',
    'Source Sans 3',
    'IM Fell English',
    'Oxygen Mono',
    'Vazirmatn',
    'Copse',
    'Jockey One',
    'Marmelad',
    'Encode Sans Semi Condensed',
    'Schoolbell',
    'Allan',
    'Gugi',
    'Marvel',
    'Dawning of a New Day',
    'Radley',
    'Rasa',
    'Hanuman',
    'Spectral SC',
    'Thasadith',
    'Lemon',
    'Zen Kaku Gothic New',
    'Mallanna',
    'Brawler',
    'Kelly Slab',
    'Metrophobic',
    'Hepta Slab',
    'Mr De Haviland',
    'Vesper Libre',
    'Kadwa',
    'Duru Sans',
    'Oxanium',
    'Limelight',
    'Belgrano',
    'Cormorant Upright',
    'Goudy Bookletter 1911',
    'Patrick Hand SC',
    'Georama',
    'Gabriela',
    'Fanwood Text',
    'Waiting for the Sunrise',
    'Bungee Shade',
    'Grenze Gotisch',
    'Noto Sans Hebrew',
    'Baloo Tamma 2',
    'Kiwi Maru',
    'B612 Mono',
    'Love Ya Like A Sister',
    'Uncial Antiqua',
    'Noto Sans Bengali',
    'Tenali Ramakrishna',
    'Turret Road',
    'Mirza',
    'Baloo Da 2',
    'Sansita Swashed',
    'IM Fell DW Pica',
    'Big Shoulders Text',
    'Bentham',
    'UnifrakturMaguntia',
    'Convergence',
    'Grape Nuts',
    'Fahkwang',
    'Nova Mono',
    'Fondamento',
    'Cutive',
    'Fjord One',
    'Kurale',
    'Baloo Chettan 2',
    'Cormorant SC',
    'Habibi',
    'Noto Serif HK',
    'Stardos Stencil',
    'Gurajada',
    'B612',
    'Megrim',
    'Inknut Antiqua',
    'Noto Sans Mono',
    'Quando',
    'Irish Grover',
    'League Gothic',
    'Poly',
    'Roboto Serif',
    'Sue Ellen Francisco',
    'Euphoria Script',
    'Yatra One',
    'Harmattan',
    'Carme',
    'Pompiere',
    'Baloo Paaji 2',
    'Emilys Candy',
    'Zeyada',
    'Happy Monkey',
    'Chelsea Market',
    'Noto Sans Kannada',
    'Federo',
    'Gravitas One',
    'Sedgwick Ave',
    'Inder',
    'Cambo',
    'Antic Didone',
    'Rakkas',
    'Vollkorn SC',
    'RocknRoll One',
    'Elsie',
    'Mouse Memoirs',
    'Rouge Script',
    'Meddon',
    'Caladea',
    'Buenard',
    'Farro',
    'Italiana',
    'Oregano',
    'Homenaje',
    'Montez',
    'Poller One',
    'Andika',
    'KoHo',
    'Allison',
    'Expletus Sans',
    'Lily Script One',
    'Galada',
    'Dokdo',
    'Newsreader',
    'Raleway Dots',
    'IM Fell Double Pica',
    'Petrona',
    'Give You Glory',
    'Noto Sans Gurmukhi',
    'Reggae One',
    'Walter Turncoat',
    'Meera Inimai',
    'Mansalva',
    'Original Surfer',
    'Codystar',
    'Almendra',
    'Ceviche One',
    'Major Mono Display',
    'Aref Ruqaa',
    'Trykker',
    'Shippori Mincho B1',
    'Battambang',
    'Della Respira',
    'Koulen',
    'Katibeh',
    'ZCOOL XiaoWei',
    'Pirata One',
    'Montserrat Subrayada',
    'Port Lligat Slab',
    'McLaren',
    'Aguafina Script',
    'Baumans',
    'Gayathri',
    'Shojumaru',
    'Metamorphous',
    'Atma',
    'Anaheim',
    'Freckle Face',
    'Odibee Sans',
    'Delius Swash Caps',
    'Finger Paint',
    'Fredoka',
    'Bellota Text',
    'Numans',
    'Ledger',
    'Supermercado One',
    'Goblin One',
    'Coiny',
    'Share Tech',
    'Saira Stencil One',
    'Orienta',
    'Vast Shadow',
    'Doppio One',
    'Encode Sans Expanded',
    'Modak',
    'Clicker Script',
    'Anek Malayalam',
    'Glory',
    'IBM Plex Sans KR',
    'Timmana',
    'Over the Rainbow',
    'Notable',
    'Lexend Zetta',
    'Ruslan Display',
    'Artifika',
    'Wendy One',
    'ZCOOL QingKe HuangYou',
    'Mukta Mahee',
    'Lekton',
    'Oooh Baby',
    'Ranchers',
    'Baloo Tammudu 2',
    'Recursive',
    'Montaga',
    'Ma Shan Zheng',
    'Averia Sans Libre',
    'Headland One',
    'Kodchasan',
    'Andada Pro',
    'Pavanam',
    'Eater',
    'Shanti',
    'Tomorrow',
    'Solway',
    'Libre Barcode 39 Text',
    'Carrois Gothic SC',
    'Yusei Magic',
    'Aboreto',
    'Anek Telugu',
    'Noto Nastaliq Urdu',
    'Balthazar',
    'Square Peg',
    'Scope One',
    'Geo',
    'Dela Gothic One',
    'Bilbo Swash Caps',
    'Sail',
    'Inria Sans',
    'Flamenco',
    'Tienne',
    'Noto Sans Gujarati',
    'Dynalight',
    'Voces',
    'Silkscreen',
    'Shalimar',
    'Prosto One',
    'Noto Sans Oriya',
    'Baloo Bhai 2',
    'IBM Plex Sans Thai',
    'Loved by the King',
    'Faster One',
    'Chau Philomene One',
    'Asul',
    'Mako',
    'Kufam',
    'Sarpanch',
    'Alumni Sans Pinstripe',
    'Salsa',
    'Crafty Girls',
    'Goldman',
    'The Girl Next Door',
    'Cherry Cream Soda',
    'Encode Sans Semi Expanded',
    'Averia Gruesa Libre',
    'DotGothic16',
    'Mountains of Christmas',
    'Peralta',
    'Amarante',
    'Brygada 1918',
    'Life Savers',
    'Germania One',
    'Nova Round',
    'Imprima',
    'MuseoModerno',
    'Jomhuria',
    'Noto Sans Sinhala',
    'Alumni Sans Collegiate One',
    'Gaegu',
    'Libre Bodoni',
    'Cherry Swash',
    'Zen Old Mincho',
    'Ibarra Real Nova',
    'Ramaraja',
    'Besley',
    'Coda Caption',
    'Strait',
    'Just Me Again Down Here',
    'Vibur',
    'Albert Sans',
    'Gamja Flower',
    'Lexend Exa',
    'MedievalSharp',
    'DynaPuff',
    'Cormorant Unicase',
    'Bubbler One',
    'Gafata',
    'Mina',
    'Port Lligat Sans',
    'Inspiration',
    'Cantora One',
    'Charmonman',
    'Delius Unicase',
    'Iceland',
    'Rowdies',
    'Inria Serif',
    'League Script',
    'Stoke',
    'Spicy Rice',
    'Denk One',
    'Tauri',
    'Sonsie One',
    'Wire One',
    'Libre Caslon Display',
    'Noto Serif Malayalam',
    'Frijole',
    'Prociono',
    'Akshar',
    'Trade Winds',
    'Slackey',
    'Unkempt',
    'Baloo Bhaina 2',
    'Zilla Slab Highlight',
    'Nova Square',
    'Libre Barcode 128',
    'Alumni Sans',
    'Rationale',
    'Bigshot One',
    'Yeon Sung',
    'Noto Serif Tamil',
    'Hurricane',
    'Paprika',
    'Medula One',
    'Sulphur Point',
    'Sree Krushnadevaraya',
    'UnifrakturCook',
    'Sumana',
    'Overlock SC',
    'Bilbo',
    'Noto Sans Tamil Supplement',
    'Sarina',
    'Song Myung',
    'Puritan',
    'Kranky',
    'Ewert',
    'Redressed',
    'Chango',
    'Londrina Outline',
    'Ranga',
    'Dekko',
    'Kaisei Decol',
    'Farsan',
    'Manuale',
    'Stylish',
    'Nova Flat',
    'Londrina Shadow',
    'Style Script',
    'Khmer',
    'Gotu',
    'Mystery Quest',
    'Ribeye',
    'Bellota',
    'Klee One',
    'Trispace',
    'Libre Barcode 39 Extended Text',
    'IM Fell French Canon',
    'Cute Font',
    'Smooch',
    'M PLUS 1',
    'Red Rose',
    'Rosarivo',
    'Asar',
    'Julee',
    'Iceberg',
    'Miniver',
    'Stalemate',
    'Fontdiner Swanky',
    'Sancreek',
    'Lovers Quarrel',
    'ZCOOL KuaiLe',
    'Engagement',
    'Zen Kaku Gothic Antique',
    'Sirin Stencil',
    'Potta One',
    'Akronim',
    'Macondo Swash Caps',
    'Kaisei Tokumin',
    'BIZ UDPGothic',
    'Crushed',
    'Zen Kurenaido',
    'Akaya Telivigala',
    'Simonetta',
    'Offside',
    'Train One',
    'Rum Raisin',
    'Nokora',
    'Kulim Park',
    'Milonga',
    'Red Hat Mono',
    'Margarine',
    'Ruthie',
    'Varta',
    'Wellfleet',
    'Buda',
    'Englebert',
    'Kotta One',
    'Stint Ultra Condensed',
    'Stick',
    'Stint Ultra Expanded',
    'New Rocker',
    'Chicle',
    'Ravi Prakash',
    'Text Me One',
    'Fenix',
    'Donegal One',
    'Bayon',
    'Marko One',
    'Hachi Maru Pop',
    'Azeret Mono',
    'Vampiro One',
    'Ruluko',
    'Orelega One',
    'Sura',
    'Viaoda Libre',
    'Swanky and Moo Moo',
    'East Sea Dokdo',
    'Mochiy Pop One',
    'Bona Nova',
    'Cagliostro',
    'Felipa',
    'Chathura',
    'Ephesis',
    'Big Shoulders Stencil Display',
    'Kumar One',
    'IM Fell Great Primer',
    'Kavivanar',
    'Kantumruy',
    'Autour One',
    'Inika',
    'Sahitya',
    'Eagle Lake',
    'Condiment',
    'Monofett',
    'Angkor',
    'Piazzolla',
    'Gorditas',
    'Chilanka',
    'Freehand',
    'Noto Sans Georgian',
    'Baloo Bhaijaan 2',
    'Barrio',
    'MonteCarlo',
    'M PLUS 2',
    'WindSong',
    'Tulpen One',
    'Hahmlet',
    'Modern Antiqua',
    'Lakki Reddy',
    'Molle',
    'Tiro Kannada',
    'Scheherazade New',
    'Content',
    'Noto Emoji',
    'Bahianita',
    'Linden Hill',
    'Underdog',
    'Peddana',
    'Tourney',
    'Croissant One',
    'Mochiy Pop P One',
    'Piedra',
    'Galdeano',
    'Metal Mania',
    'Bigelow Rules',
    'Noto Sans Myanmar',
    'Elsie Swash Caps',
    'Jomolhari',
    'Lexend Mega',
    'Yaldevi',
    'Dorsa',
    'Anek Latin',
    'Junge',
    'Gowun Batang',
    'IBM Plex Sans Thai Looped',
    'Rubik Dirt',
    'Nosifer',
    'Meie Script',
    'Kaisei Opti',
    'Comforter',
    'Kavoon',
    'Jolly Lodger',
    'Griffy',
    'Joti One',
    'Maiden Orange',
    'Murecho',
    'Beth Ellen',
    'Hina Mincho',
    'Lexend Giga',
    'Libre Barcode 128 Text',
    'Caesar Dressing',
    'Nerko One',
    'Bahiana',
    'Srisakdi',
    'Akaya Kanadaka',
    'Diplomata',
    'Zen Antique',
    'Kirang Haerang',
    'Spline Sans',
    'Odor Mean Chey',
    'IM Fell DW Pica SC',
    'Arbutus',
    'Rubik Maze',
    'Karantina',
    'Noto Sans Symbols',
    'Risque',
    'Radio Canada',
    'Spirax',
    'Jim Nightshade',
    'Plaster',
    'Lancelot',
    'Mrs Sheppards',
    'Romanesco',
    'Fascinate',
    'Ribeye Marrow',
    'Arima',
    'Birthstone',
    'Diplomata SC',
    'Mogra',
    'IM Fell French Canon SC',
    'Siemreap',
    'Revalia',
    'Unlock',
    'Yomogi',
    'Devonshire',
    'New Tegomin',
    'Galindo',
    'Poor Story',
    'Rhodium Libre',
    'Noto Serif Thai',
    'Nova Slim',
    'Grenze',
    'Gemunu Libre',
    'Moul',
    'Smythe',
    'Keania One',
    'Chenla',
    'Bungee Outline',
    'Almendra SC',
    'Emblema One',
    'Girassol',
    'Tiro Devanagari Sanskrit',
    'Jacques Francois',
    'BIZ UDPMincho',
    'Jacques Francois Shadow',
    'Oldenburg',
    'Smokum',
    'Rampart One',
    'Bakbak One',
    'Vujahday Script',
    'Rubik Moonrocks',
    'Road Rage',
    'Hanalei',
    'Zhi Mang Xing',
    'Beau Rivage',
    'Noto Serif Balinese',
    'Mohave',
    'Glass Antiqua',
    'Rubik Distressed',
    'IM Fell Great Primer SC',
    'Tiro Gurmukhi',
    'Sedgwick Ave Display',
    'Hanalei Fill',
    'Federant',
    'Princess Sofia',
    'Zen Dots',
    'Atomic Age',
    'Dr Sugiyama',
    'Flavors',
    'Tiro Devanagari Hindi',
    'Barriecito',
    'Shippori Antique',
    'BIZ UDGothic',
    'Benne',
    'Seymour One',
    'BioRhyme Expanded',
    'Nuosu SIL',
    'Fascinate Inline',
    'Miss Fajardose',
    'Londrina Sketch',
    'Rubik Iso',
    'Snippet',
    'Noto Serif Kannada',
    'Joan',
    'Encode Sans SC',
    'Syne Mono',
    'Licorice',
    'Asset',
    'Spline Sans Mono',
    'The Nautigal',
    'Texturina',
    'Festive',
    'Dangrek',
    'GFS Neohellenic',
    'Stalinist One',
    'Almendra Display',
    'Suwannaphum',
    'Gowun Dodum',
    'Anek Tamil',
    'Noto Serif Devanagari',
    'Chela One',
    'Noto Sans Armenian',
    'BIZ UDMincho',
    'Liu Jian Mao Cao',
    'Metal',
    'Moulpali',
    'Libre Barcode 39 Extended',
    'Gantari',
    'Bungee Hairline',
    'Gluten',
    'Long Cang',
    'Fruktur',
    'Kdam Thmor Pro',
    'Bonbon',
    'Mr Bedfort',
    'Zen Antique Soft',
    'M PLUS 1 Code',
    'Carattere',
    'Big Shoulders Stencil Text',
    'Gidugu',
    'Zen Loop',
    'Passero One',
    'Trochut',
    'Bokor',
    'Nova Oval',
    'Yuji Syuku',
    'Noto Sans Gothic',
    'Anek Bangla',
    'Butterfly Kids',
    'Erica One',
    'Montagu Slab',
    'Fuzzy Bubbles',
    'Birthstone Bounce',
    'Corinthia',
    'Fuggles',
    'Qahiri',
    'Kumar One Outline',
    'Combo',
    'Shippori Antique B1',
    'Rubik Burned',
    'Noto Sans Math',
    'Anybody',
    'Imbue',
    'Astloch',
    'Praise',
    'Gulzar',
    'Rubik Marker Hatch',
    'IM Fell Double Pica SC',
    'Snowburst One',
    'Anek Devanagari',
    'Taprom',
    'Purple Purse',
    'Noto Serif Telugu',
    'Black And White Picture',
    'Lavishly Yours',
    'Bonheur Royale',
    'Suravaram',
    'Sunshiney',
    'Edu SA Beginner',
    'Lexend Tera',
    'Vibes',
    'Figtree',
    'Lacquer',
    'Tai Heritage Pro',
    'Noto Sans Samaritan',
    'Ruge Boogie',
    'Miltonian',
    'Rubik Glitch',
    'Butcherman',
    'Langar',
    'Sofadi One',
    'Noto Sans Tai Viet',
    'Comforter Brush',
    'Nova Script',
    'Waterfall',
    'Kaisei HarunoUmi',
    'Nova Cut',
    'Aubrey',
    'Miltonian Tattoo',
    'Smooch Sans',
    'Stick No Bills',
    'Lexend Peta',
    'Sevillana',
    'Edu TAS Beginner',
    'Rubik Microbe',
    'Ms Madi',
    'Gupter',
    'Edu QLD Beginner',
    'Syne Tactile',
    'Tiro Bangla',
    'Petemoss',
    'Single Day',
    'Whisper',
    'Charis SIL',
    'Preahvihear',
    'Water Brush',
    'Tiro Devanagari Marathi',
    'Big Shoulders Inline Text',
    'Ballet',
    'Luxurious Script',
    'Mea Culpa',
    'Dhurjati',
    'Zen Tokyo Zoo',
    'Edu VIC WA NT Beginner',
    'Moon Dance',
    'Gwendolyn',
    'Fleur De Leah',
    'Geostar Fill',
    'Imperial Script',
    'Hubballi',
    'Kenia',
    'Edu NSW ACT Foundation',
    'Meow Script',
    'Xanh Mono',
    'Neonderthaw',
    'Rubik Beastly',
    'Fasthand',
    'Truculenta',
    'Noto Sans Thai Looped',
    'Uchen',
    'Familjen Grotesk',
    'Tapestry',
    'Tiro Telugu',
    'Noto Sans Symbols 2',
    'Alumni Sans Inline One',
    'Rubik Wet Paint',
    'Flow Circular',
    'IBM Plex Sans Devanagari',
    'Noto Serif Khmer',
    'Anek Gujarati',
    'Geostar',
    'Finlandica',
    'IBM Plex Sans Hebrew',
    'Gentium Book Plus',
    'Splash',
    'Gideon Roman',
    'Big Shoulders Inline Display',
    'Genos',
    'BhuTuka Expanded One',
    'Kantumruy Pro',
    'Gentium Plus',
    'Luxurious Roman',
    'Koh Santepheap',
    'Warnes',
    'Love Light',
    'Anek Gurmukhi',
    'Updock',
    'Send Flowers',
    'Yuji Boku',
    'Grechen Fuemen',
    'Noto Sans Javanese',
    'Noto Sans Lao',
    'Oi',
    'Noto Sans Khmer',
    'Yuji Mai',
    'Cherish',
    'Noto Serif Nyiakeng Puachue Hmong',
    'Noto Serif Gujarati',
    'Tiro Tamil',
    'Anek Kannada',
    'Are You Serious',
    'Noto Serif Georgian',
    'Mingzat',
    'Noto Sans Ogham',
    'Libre Barcode EAN13 Text',
    'Noto Sans Avestan',
    'Rubik Bubbles',
    'Blaka Hollow',
    'Noto Serif Sinhala',
    'Blaka',
    'My Soul',
    'Noto Sans Egyptian Hieroglyphs',
    'Babylonica',
    'Passions Conflict',
    'Noto Sans Balinese',
    'Noto Music',
    'Noto Sans Carian',
    'Noto Serif Armenian',
    'Ole',
    'Moo Lah Lah',
    'Anek Odia',
    'Redacted Script',
    'Noto Serif Hebrew',
    'Estonia',
    'Noto Sans Saurashtra',
    'Explora',
    'Grey Qo',
    'Island Moments',
    'Sassy Frass',
    'Noto Serif Ethiopic',
    'Noto Rashi Hebrew',
    'Noto Sans Deseret',
    'Twinkle Star',
    'Rubik Puddles',
    'Ingrid Darling',
    'Noto Sans Sora Sompeng',
    'Kings',
    'Caramel',
    'M PLUS Code Latin',
    'Noto Sans Thaana',
    'Puppies Play',
    'Kolker Brush',
    'Noto Serif Lao',
    'Flow Rounded',
    'Flow Block',
    'Redacted',
    'Noto Traditional Nushu',
    'Noto Sans Old Turkic',
    'Noto Sans Cherokee',
    'Noto Sans Multani',
    'Noto Sans Adlam',
    'Noto Sans Mro',
    'Noto Sans Brahmi',
    'Noto Sans Canadian Aboriginal',
    'Noto Serif Tibetan',
    'Noto Sans Tagalog',
    'Noto Sans Bamum',
    'Noto Sans Imperial Aramaic',
    'Noto Sans Meetei Mayek',
    'Noto Sans Coptic',
    'Noto Sans Mongolian',
    'Noto Serif Myanmar',
    'Noto Sans Cham',
    'Noto Sans Anatolian Hieroglyphs',
    'Noto Sans Hanunoo',
    'Noto Sans Ol Chiki',
    'Noto Sans Old Persian',
    'Noto Serif Gurmukhi',
    'Noto Sans Syriac',
    'Noto Sans Adlam Unjoined',
    'Noto Sans Old Italic',
    'Noto Sans Cypriot',
    'Noto Sans Yi',
    'Noto Sans Lisu',
    'Noto Serif Yezidi',
    'Noto Sans Buginese',
    'Noto Sans Linear A',
    'Noto Sans Buhid',
    'Noto Serif Dogra',
    'Noto Sans Indic Siyaq Numbers',
    'Noto Sans Sundanese',
    'Noto Sans Psalter Pahlavi',
    'Noto Sans Grantha',
    'Noto Sans N Ko',
    'Noto Sans Medefaidrin',
    'Noto Serif Ahom',
    'Noto Sans Syloti Nagri',
    'Noto Sans Old Hungarian',
    'Noto Sans Tifinagh',
    'Noto Sans Phags Pa',
    'Noto Sans Old South Arabian',
    'Noto Sans Inscriptional Parthian',
    'Noto Sans Kaithi',
    'Noto Sans Bhaiksuki',
    'Noto Sans Batak',
    'Noto Sans Pahawh Hmong',
    'Noto Sans Wancho',
    'Noto Sans Marchen',
    'Noto Serif Tangut',
    'Noto Sans Pau Cin Hau',
    'Noto Sans Inscriptional Pahlavi',
    'Noto Sans Caucasian Albanian',
    'Noto Sans Osage',
    'Noto Sans Bassa Vah',
    'Noto Sans Palmyrene',
    'Noto Sans Tai Tham',
    'Noto Sans Kharoshthi',
    'Noto Sans Mayan Numerals',
    'Noto Sans Runic',
    'Noto Sans Duployan',
    'Noto Sans Kayah Li',
    'Noto Sans Hanifi Rohingya',
    'Noto Sans Cuneiform',
    'Noto Sans Masaram Gondi',
    'Noto Sans Old North Arabian',
    'Noto Sans Glagolitic',
    'Noto Serif Grantha',
    'Noto Sans Zanabazar Square',
    'Noto Sans Sharada',
    'Noto Sans Warang Citi',
    'Noto Sans Hatran',
    'Noto Sans Phoenician',
    'Noto Sans Newa',
    'Noto Sans Lepcha',
    'Noto Sans Ugaritic',
    'Noto Sans New Tai Lue',
    'Noto Sans Tagbanwa',
    'Noto Sans Khojki',
    'Noto Sans Mandaic',
    'Noto Sans Osmanya',
    'Noto Sans Takri',
    'Noto Sans Mahajani',
    'Noto Sans Siddham',
    'Noto Sans Elbasan',
    'Noto Sans Chakma',
    'Noto Sans Linear B',
    'Noto Sans Soyombo',
    'Noto Sans Nushu',
    'Noto Sans Modi',
    'Noto Sans Vai',
    'Noto Sans Limbu',
    'Noto Sans Manichaean',
    'Noto Sans Sogdian',
    'Noto Sans Rejang',
    'Noto Sans Elymaic',
    'Noto Sans Tai Le',
    'Noto Sans Lydian',
    'Noto Sans Gunjala Gondi',
    'Noto Sans Tirhuta',
    'Noto Sans Old Permic',
    'Noto Sans Nabataean',
    'Noto Sans Khudawadi',
    'Noto Sans Shavian',
    'Noto Sans Lycian',
    'Noto Sans Meroitic',
    'Noto Sans Old Sogdian',
    'Noto Sans Miao',
]

export const THEME_OPTIONS = [
    { value: "Clear", label: "Clear" },
    { value: "Classic", label: "Classic" },
];

export const THEME_IMAGE = {
    'Default' : `${process.env.PUBLIC_URL}/img/theme/Original.png`,
    'Clear' : `${process.env.PUBLIC_URL}/img/theme/Original.png`,
    'Classic' : `${process.env.PUBLIC_URL}/img/theme/New.png`,
}


export const DEFAULT_OPTIONS = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
];

export const MEDIA_FIELDS = ['small_logo', 'big_logo', 'hero_banner', 'slider_01', 'slider_02', 'slider_03']
